import { graphql } from "react-relay";

// gql
import "@components/draggable-working-hours/DraggableWorkingHours.gql";

export const webAppWorkingHoursFragments = {
  viewer: graphql`
    fragment WebAppWorkingHours_viewer on Viewer {
      user {
        orgs(first: 1000000) {
          edges {
            node {
              userWorkingHours(resolveOverrides: false) {
                workingHours {
                  ...DraggableWorkingHours_workingHours
                }
              }
            }
          }
        }
      }
    }
  `,
};

export const webAppWorkingHoursQuery = graphql`
  query WebAppWorkingHoursQuery {
    viewer {
      ...WebAppWorkingHours_viewer
    }
  }
`;
